import api from "../Utils/axios";
import { adminV1Base } from "../Utils/connection_strings";

export const getContactInquiries = (
  page = 1,
  perPage = 10,
  search_string = "",
  status = "",
  from = "",
  to = ""
) => {
  return api.post(`${adminV1Base}/contact-inquiry/get`, {
    page,
    limit: perPage,
    keyword: search_string || "",
    status: status || undefined,
    from: from || undefined,
    to: to || undefined,
    sort: -1
  });
};

export const getContactInquiryDetails = (id) => {
  return api.post(`${adminV1Base}/contact-inquiry/details`, { id });
};

export const updateContactInquiryStatus = (id, status) => {
  return api.post(`${adminV1Base}/contact-inquiry/update-status`, { id, status });
};

export const deleteContactInquiry = (id) => {
  return api.post(`${adminV1Base}/contact-inquiry/delete`, { id });
};

export const replyContactInquiry = (id, message, subject = "") => {
  return api.post(`${adminV1Base}/contact-inquiry/reply`, { id, message, subject });
};
